import script from "./step13OfferHR.vue?vue&type=script&setup=true&lang=ts"
export * from "./step13OfferHR.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__